import { downloadQRCode } from "../components/utils/qrUtils";
import { useNotification } from "../context/NotificationContext";
import shortfyLogoPng from "../assets/images/Shortfy-Logo.png";

const useQRCodeDownloader = (
  shortenedUrls: Record<string, any>,
  includeDisclaimer = true,
) => {
  const { setNotification } = useNotification();

  const handleDownloadQRCode = async (
    shortCode: string,
    format?: "png" | "svg",
  ) => {
    try {
      const stored = shortenedUrls?.[shortCode];
      const fileFormat = format || stored?.fileFormat || "png";
      const name = stored?.name || stored?.ssid || "qr-code";

      const qrCodeElementId = `qr-code-${shortCode}`;
      const qrCodeElement = document.getElementById(qrCodeElementId);

      if (!qrCodeElement) {
        setNotification({ type: "error", message: "QR Code not found." });
        return;
      }

      const logoImg = qrCodeElement.querySelector(
        ".logo-img",
      ) as HTMLImageElement;

      await downloadQRCode({
        fileName: name,
        format: fileFormat,
        qrCodeElementId,
        logoUrl: logoImg?.src,
        withLogo: !!logoImg,
        includeDisclaimer,
        shortfyLogoUrl: shortfyLogoPng,
      });

      setNotification({
        type: "success",
        message: `QR code downloaded as ${fileFormat.toUpperCase()} successfully!`,
      });
    } catch (error) {
      setNotification({
        type: "error",
        message: "There was an error downloading the QR code.",
      });
    }
  };

  return { handleDownloadQRCode };
};

export default useQRCodeDownloader;
